import React from 'react';
import { injectIntl } from 'react-intl';
import AdviserInfoCardAbstract from '../AdviserInfoCardAbstract/AdviserInfoCardAbstract';
import { Button, Grid, IconButton } from '@mui/material';
import MyEditor from '../../../components/MyEditor/MyEditor';
import { formatEditorStateValue, getEditorDefaultMessage } from '../../../utils/editor';
import { formatOpenUrl } from '../../../utils/url';
import { toast } from 'react-toastify';
import IconToast from '../../../components/NewToast';
import NativeOrWeb from '../../../utils/native';
import { ADVISER_LOGO_FUNCTIONS } from '../../../constants/user';
import { getUserLogo } from '../../../utils/user';

const FullWidthStyle = {
  width: '100%'
};

const LogoImageStyle = {
  width: '100%',
  maxHeight: 100,
  objectFit: 'contain'
};

const TeamPageButtonStyle = {
  minHeight: 'unset',
  minWidth: 'unset',
  padding: '6px 18px',
  borderRadius: '16px',
  lineHeight: 1
};

const ImageButtonStyle = {
  padding: 6
};

const ImageStyle = {
  width: 20,
  height: 20
};

const AdviserInfoPageTeam = props => {
  const { intl, adviserInfo, isIntoView } = props;

  const {
    shouldShowProfilePlusTeamLogo,
    teamDescription,
    teamPage,
    teamInstagram,
    teamFacebook,
    teamLinkedin,
    teamWechat,
    teamLogoUrl
  } = adviserInfo || {};

  const formattedTeamLogoUrl = getUserLogo(
    adviserInfo,
    shouldShowProfilePlusTeamLogo && teamLogoUrl,
    ADVISER_LOGO_FUNCTIONS.PROFILE_PLUS
  );
  const formattedTeamDescription = formatEditorStateValue(
    teamDescription || getEditorDefaultMessage(intl.locale, 'profile-plus-team-description')
  );

  const goTeamPage = () => {
    window.open(formatOpenUrl(teamPage), '_blank');
  };

  const goInstagram = () => {
    window.open(formatOpenUrl(`https://www.instagram.com/${teamInstagram}`), '_blank');
  };

  const goFacebook = () => {
    window.open(formatOpenUrl(teamFacebook), '_blank');
  };

  const goLinkedin = () => {
    window.open(formatOpenUrl(teamLinkedin), '_blank');
  };

  // Toast only when the copy actually landed — see the note on `copyToClipboard` for what the
  // web path can and cannot promise. Unlike the WeChat id on the contact card, this one is behind
  // an icon and is not shown, so a failed copy leaves the visitor with nothing to fall back on.
  const goWechat = async () => {
    let copied = false;
    try {
      copied = await NativeOrWeb.copyToClipboard(teamWechat);
    } catch (error) {
      // leave copied false
    }

    if (copied) {
      toast.info(IconToast('info', intl.formatMessage({ id: 'Copied!' })), {
        className: 'new-toast'
      });
    }
  };

  return (
    <AdviserInfoCardAbstract
      className="adviser-info-page-team"
      title={intl.formatMessage({ id: 'adv-info-team-title' })}
      adviserInfo={adviserInfo}
      contentHeight="calc(100% - 110px)"
      isIntoView={isIntoView}
    >
      <Grid container wrap="nowrap" style={{ height: '100%' }} sx={{ flexDirection: 'column' }}>
        <Grid style={{ ...FullWidthStyle, flexGrow: 1 }} className="content-container">
          <Grid
            container
            wrap="nowrap"
            spacing={3}
            style={{ height: '100%' }}
            sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
          >
            {formattedTeamLogoUrl && (
              <Grid style={FullWidthStyle}>
                <img src={formattedTeamLogoUrl} alt="team-logo" style={LogoImageStyle} />
              </Grid>
            )}
            <Grid style={{ ...FullWidthStyle, flexGrow: 1, overflow: 'auto' }}>
              <MyEditor editorState={formattedTeamDescription} readOnly={true} />
            </Grid>
            {(teamPage || teamInstagram || teamFacebook || teamLinkedin || teamWechat) && (
              <Grid style={FullWidthStyle}>
                <Grid container spacing={1}>
                  {teamPage && (
                    <Grid size={12}>
                      <Grid
                        container
                        sx={{
                          justifyContent: 'center'
                        }}
                      >
                        <Grid>
                          <Button color="primary" variant="contained" onClick={goTeamPage} style={TeamPageButtonStyle}>
                            {intl.formatMessage({ id: 'mda-team-page' })}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {(teamInstagram || teamFacebook || teamLinkedin || teamWechat) && (
                    <Grid size={12}>
                      <Grid
                        container
                        spacing={1}
                        sx={{
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {teamInstagram && (
                          <Grid>
                            <IconButton onClick={goInstagram} style={ImageButtonStyle} size="large">
                              <img src="img/instagram.svg" alt="instagram" style={ImageStyle} />
                            </IconButton>
                          </Grid>
                        )}

                        {teamFacebook && (
                          <Grid>
                            <IconButton onClick={goFacebook} style={ImageButtonStyle} size="large">
                              <img src="img/facebook.svg" alt="facebook" style={ImageStyle} />
                            </IconButton>
                          </Grid>
                        )}

                        {teamLinkedin && (
                          <Grid>
                            <IconButton onClick={goLinkedin} style={ImageButtonStyle} size="large">
                              <img src="img/linkedin.svg" alt="linkedin" style={ImageStyle} />
                            </IconButton>
                          </Grid>
                        )}

                        {teamWechat && (
                          <Grid>
                            <IconButton onClick={goWechat} style={ImageButtonStyle} size="large">
                              <img src="img/wechat.svg" alt="wechat" style={ImageStyle} />
                            </IconButton>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </AdviserInfoCardAbstract>
  );
};

export default injectIntl(AdviserInfoPageTeam);
